import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "state", "country"]

  connect() {
    this.observer = null
    this.geocoder = new MapboxGeocoder({
      accessToken: this.authToken,
      types: 'place', // Utilise 'place' pour les villes/localités
      mapboxgl: false,
      placeholder: 'Rechercher une ville...'
    })

    this.geocoder.on('result', (event) => {
      this.updateCityField(event)
    })

    // Insérer le geocoder dans le DOM
    const geocoderElement = this.geocoder.onAdd()
    this.element.appendChild(geocoderElement)

    // Styler le container du geocoder
    geocoderElement.classList.add('!w-full', '!max-w-none')
    
    // Cacher l'icône de recherche (loupe) à gauche
    const searchIcon = geocoderElement.querySelector('.mapboxgl-ctrl-geocoder--icon')
    if (searchIcon) {
      searchIcon.style.display = 'none'
    }
    
    // Appliquer les styles AdminForms au champ input Mapbox pour correspondre au design system
    const geocoderInput = geocoderElement.querySelector('input')
    if (geocoderInput) {
      // Supprimer les styles par défaut de Mapbox
      geocoderInput.className = ''
      
      // Appliquer les classes consistantes avec les autres champs du formulaire + padding ajusté sans icône
      geocoderInput.classList.add(
        'block', 'w-full', 'rounded-lg', 'border-2', 'border-gray-300', 
        'bg-white', 'px-3', 'py-2', 'text-sm', 'text-gray-900',
        'placeholder-gray-500', 'transition-colors', 'duration-200',
        'focus:border-green-400', 'focus:outline-none', 'focus:ring-0',
        'hover:border-gray-400'
      )
      
      // Supprimer le padding à gauche puisqu'il n'y a plus d'icône
      geocoderInput.style.paddingLeft = '12px'
      
      // Si il y a déjà une valeur dans le champ caché, l'afficher
      if (this.inputTarget.value) {
        geocoderInput.value = this.inputTarget.value
      }
    }

    // Styler la liste de suggestions pour correspondre au design
    const suggestionsList = geocoderElement.querySelector('.suggestions')
    if (suggestionsList) {
      suggestionsList.classList.add(
        '!border-gray-300', '!rounded-lg', '!shadow-lg', '!border-2',
        '!bg-white', '!mt-1'
      )
    }

    // Styler les éléments de suggestion individuels avec un observer
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const suggestions = geocoderElement.querySelectorAll('.mapboxgl-ctrl-geocoder--suggestion')
          suggestions.forEach(suggestion => {
            suggestion.classList.add(
              '!px-3', '!py-2', '!text-sm', '!text-gray-900',
              'hover:!bg-green-50', '!border-b', '!border-gray-100'
            )
          })
        }
      })
    })
    
    this.observer.observe(geocoderElement, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  updateCityField(event) {
    // Mettre à jour le champ caché avec la ville sélectionnée
    if (this.hasInputTarget) {
      this.inputTarget.value = event.result.text
    }

    // Extraire state et country depuis le contexte Mapbox
    const context = event.result.context || []

    // Trouver la région/état (id commence par "region")
    const regionContext = context.find(c => c.id.startsWith('region'))
    if (this.hasStateTarget && regionContext) {
      this.stateTarget.value = regionContext.text
    } else if (this.hasStateTarget) {
      this.stateTarget.value = ''
    }

    // Trouver le pays (id commence par "country")
    const countryContext = context.find(c => c.id.startsWith('country'))
    if (this.hasCountryTarget && countryContext) {
      this.countryTarget.value = countryContext.text
    } else if (this.hasCountryTarget) {
      this.countryTarget.value = ''
    }
  }

  get authToken() {
    return document.head.querySelector('meta[name="mapbox_token"]').content;
  }
}